import { useDatasetStore } from '@/src/store/datasets';
import { useDICOMStore } from '@/src/store/datasets-dicom';
import { useImageStore } from '@/src/store/datasets-images';

/**
 * Whether the viewer currently has a loaded scan (DICOM volume or regular image).
 * Meshes alone do not count as a scan.
 */
export function hasLoadedScan(): boolean {
  const dicomStore = useDICOMStore();
  const imageStore = useImageStore();
  return (
    Object.keys(dicomStore.volumeInfo).length > 0 ||
    imageStore.idList.length > 0
  );
}

/**
 * Removes all datasets, unbinds views, and resets workspace UI tied to the
 * previous scan.
 */
export function resetViewerForNewScan() {
  useDatasetStore().resetViewerForNewScan();
}
